import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import { useHistory, useLocation } from 'react-router-dom';
import {
    Container,
    Bouton,
    LoaderMi,
    InputMi,
    Checkbox,
    Fieldset,
    BoutonRadio,
    Lien,
    Row,
    Col,
} from '@design-system-etat/dsfr-react';
import InputFiles from 'components/Commun/Form/InputFiles';
import { getDateFormatWithSlash } from 'components/Commun/Form/maskFunctions';
import { FormProvider, useForm } from 'react-hook-form';
import { getMessageErreurChampManquant, getPatternHookFormValidation } from 'utils/utils';
import { REGEXP_DATE_FR } from 'constants/contraintes.constants';
import usagerClientReducer from 'store/usagerReducer';
import {
    API_DECLARATION_ARME_PERDUE_VOLEE_RECUPERER_URL,
    API_DECLARATION_ARME_PERDUE_VOLEE_VALIDER_URL,
    CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_RECUPERER,
    CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_VALIDER,
} from 'constants/apiUrls.constants';
import { MESSAGE_DATE_NAISSANCE_INVALIDE } from 'constants/messagePersonaline.constants';
import TableauArmePerdueVolee from './TableauArmePerdueVolee';
import RoutesRatelier from '../../../ratelier/routes';
import { getPath } from '../../../../../utils/router';

const FormulaireArmePerdueVolee = ({
    dataProfil,
    postApi,
    reinitialiseApi,
    message,
    erreur,
    isLoading,
    isLoadingListeArme,
    dataListeArme,
}) => {
    const { REACT_APP_CONTACT_GENDARMERIE_POLICE_URL } = process.env;
    const [listeArmesDeclarationPerduesVolees, setListeArmesDeclarationPerduesVolees] = useState(
        [],
    );
    const location = useLocation();
    const history = useHistory();
    const hookForm = useForm({
        mode: 'onChange',
    });
    const { handleSubmit, register, formState, watch } = hookForm;
    const { isValid } = formState;
    const reinitialiserStore = () => {
        reinitialiseApi(CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_VALIDER);
        reinitialiseApi(CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_RECUPERER);
    };

    const retourRatelier = () => {
        reinitialiserStore();
        history.push(getPath(RoutesRatelier));
    };

    const formaterDataJustificatif = (donnees) => {
        return donnees.justificatif[0].getFileToSend();
    };

    const supprimerArme = (index) => {
        const listeArmesDeclarationPerduesVoleesTmp = [...listeArmesDeclarationPerduesVolees];
        listeArmesDeclarationPerduesVoleesTmp.splice(index, 1);
        setListeArmesDeclarationPerduesVolees(listeArmesDeclarationPerduesVoleesTmp);
    };

    const getBoutonAction = (index) => {
        return (
            <Bouton
                className="fr-fi-delete-line"
                niveau="primaire"
                aria-hidden="true"
                onClick={() => supprimerArme(index)}
            />
        );
    };

    const hasFormValid = () => {
        return (
            watch('situation') &&
            watch('dateRecepisseDeclaration') &&
            watch('lieuRecepisseDeclaration') &&
            watch('justificatif') &&
            watch('certificationInformation') &&
            isValid
        );
    };

    useEffect(() => {
        if (dataListeArme) {
            const listeArme = dataListeArme.map((element) => ({
                numeroEncodage: element.numeroEncodage,
                numeroCarcasse: element.numeroCarcasse,
                type: element.type,
                marque: element.marque,
                modele: element.modele,
                calibreCanon: element.calibreCanon,
                calibreCanonDeux: element.calibreCanonDeux,
                classement: element.classement,
                statut: element.statut,
                uniquid: element.uniquid,
            }));
            setListeArmesDeclarationPerduesVolees(listeArme);
        }
    }, [dataListeArme]);

    const onSubmit = (donnees) => {
        const dataToSend = donnees;
        dataToSend.listeArmes = listeArmesDeclarationPerduesVolees.map(
            (element) => element.uniquid,
        );

        // afficher une erreur si situation n'est pas selectionné
        const donneePJ = formaterDataJustificatif(dataToSend);

        donneePJ.then((value) => {
            dataToSend.justificatif = { contenu: value.contenu, libelle: value.filename };
            postApi(
                usagerClientReducer,
                API_DECLARATION_ARME_PERDUE_VOLEE_VALIDER_URL,
                dataToSend,
                CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_VALIDER,
            );
        });
    };

    useEffect(() => {
        if (message && !erreur) {
            retourRatelier();
        }
    }, [message]);

    useEffect(() => {
        reinitialiserStore();

        // Requete pour recuperer les informations des armes
        if (location.state.listeArme) {
            const data = { listeArmesUuid: location.state.listeArme };

            postApi(
                usagerClientReducer,
                API_DECLARATION_ARME_PERDUE_VOLEE_RECUPERER_URL,
                data,
                CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_RECUPERER,
            );
        }

        if (!dataProfil) {
            retourRatelier();
        }
    }, []);

    const validateDateJustificatif = (value) => {
        const dateDecoupee = value.split('/');

        if (
            new Date(dateDecoupee[2], dateDecoupee[1] - 1, dateDecoupee[0]).getTime() >
            new Date().getTime()
        ) {
            return 'Date non valide, veuillez renseigner une date valide';
        }

        return null;
    };

    return (
        dataProfil && (
            <Container margeExterne={false}>
                {isLoadingListeArme || !dataListeArme ? (
                    <LoaderMi taille="lg" />
                ) : (
                    <Row>
                        <Col>
                            <p>
                                Nombre d&apos;arme(s) perdue(s) / volée(s) :{' '}
                                {listeArmesDeclarationPerduesVolees.length} arme(s) sélectionnée(s)
                            </p>
                        </Col>
                    </Row>
                )}
                <FormProvider {...hookForm}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {!isLoadingListeArme && dataListeArme && (
                            <Row>
                                <Col>
                                    <TableauArmePerdueVolee
                                        donnees={listeArmesDeclarationPerduesVolees.map(
                                            (element, index) => {
                                                const ligne = { ...element };
                                                delete ligne.uniquid;
                                                ligne.action =
                                                    listeArmesDeclarationPerduesVolees.length > 1
                                                        ? getBoutonAction(index)
                                                        : null;

                                                return ligne;
                                            },
                                        )}
                                    />
                                </Col>
                            </Row>
                        )}
                        <Row>
                            <Col>
                                <Fieldset
                                    legendeEnGras={false}
                                    legende="Si vous avez perdu ou que vous vous êtes fait voler une arme
                                            ou un élément d'arme des catégories A, B, ou C vous devez immédiatement faire
                                            une déclaration au commissariat de police ou à la brigade de gendarmerie"
                                    texteAide="Ne pas respecter cette règle est passible d'une amende de 750 euros.
                                            Article R. 317-2 du code de la sécurité intérieure"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Fieldset legende="Où s'adresser ?" legendeEnGras>
                                    <Lien
                                        title="Ministère de l'intérieur - Contact Gendarmerie Police"
                                        href={REACT_APP_CONTACT_GENDARMERIE_POLICE_URL}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Contacter une brigade de gendarmerie ou un commissariat de
                                    </Lien>
                                </Fieldset>
                            </Col>
                        </Row>

                        <Row goutierre>
                            <Col col={6}>
                                <Fieldset legende="Situation :" alignementHorizontal legendeEnGras>
                                    <BoutonRadio
                                        type="radio"
                                        label="Perdue"
                                        value="perte"
                                        {...register('situation')}
                                    />
                                    <BoutonRadio
                                        type="radio"
                                        label="Volée"
                                        value="vol"
                                        {...register('situation')}
                                    />
                                </Fieldset>
                            </Col>
                            <Col col={6}>
                                <Row>
                                    <Col>
                                        <p>
                                            Date et lieu du récépissé de déclaration de perte ou de
                                            vol*
                                        </p>
                                    </Col>
                                </Row>
                                <Row goutierre>
                                    <Col col={6}>
                                        <InputMi
                                            name="dateRecepisseDeclaration"
                                            label="Le:"
                                            type="text"
                                            uppercase
                                            {...register('dateRecepisseDeclaration', {
                                                required: true,
                                                pattern: getPatternHookFormValidation(
                                                    REGEXP_DATE_FR,
                                                    '',
                                                    MESSAGE_DATE_NAISSANCE_INVALIDE,
                                                ),
                                                validate: (value) =>
                                                    validateDateJustificatif(value),
                                            })}
                                            placeholder="JJ/MM/AAAA"
                                            maskFonction={getDateFormatWithSlash}
                                        />
                                    </Col>
                                    <Col col={6}>
                                        <InputMi
                                            name="lieuRecepisseDeclaration"
                                            label="A:"
                                            type="text"
                                            maxLength="60"
                                            uppercase
                                            {...register('lieuRecepisseDeclaration', {
                                                required: getMessageErreurChampManquant('Lieu'),
                                            })}
                                            placeholder="Lieu"
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row goutierre>
                            <Col>
                                <InputFiles
                                    name="justificatif"
                                    label='Un récépissé de déclaration de perte ou de vol vous est alors remis, cliquer sur le bouton "Importer" pour importer le document'
                                    required
                                    error={formState.errors ? formState.errors.justificatif : null}
                                    accept=".png,.pdf,.jpeg,.jpg"
                                    texteAide="La taille maximale autorisée de votre document est 5Mo. Les formats acceptés sont .pdf, .png, .jpg, .jpeg"
                                />
                            </Col>
                        </Row>
                        <Row goutierre>
                            <Col> </Col>
                        </Row>
                        <Row goutierre className="margin-top-md">
                            <Col>
                                <Checkbox
                                    name="certificationInformations"
                                    label={`Je soussigné ${dataProfil.prenom} ${dataProfil.nom}, certifie l'exactitude des renseignements fournis *`}
                                    value
                                    required
                                    {...register('certificationInformation', {
                                        required: getMessageErreurChampManquant('Certifie'),
                                    })}
                                />
                            </Col>
                        </Row>
                        <Row goutierre>
                            <Col> </Col>
                        </Row>
                        <Row goutierre className="margin-top-lg">
                            <Col lg={6}>
                                <Bouton
                                    onClick={retourRatelier}
                                    label="Retour"
                                    niveau="secondaire"
                                />
                            </Col>
                            <Col lg={6} className="text-right">
                                <Bouton
                                    label="Valider"
                                    niveau="primaire"
                                    type="submit"
                                    disabled={!hasFormValid()}
                                    isLoading={isLoading}
                                />
                            </Col>
                        </Row>
                    </form>
                </FormProvider>
            </Container>
        )
    );
};

FormulaireArmePerdueVolee.propTypes = {
    postApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    message: PropTypes.string,
    erreur: PropTypes.bool,
    dataProfil: PropTypes.array,
    isLoadingListeArme: PropTypes.bool,
    dataListeArme: PropTypes.array,
};

export default connect(
    (state) => {
        const { data } = state.profil.usager;
        const { message, isLoading, erreur } = state.armes.signalerArmePerdueVolee.reponse;
        const { isLoading: isLoadingListeArme, data: dataListeArme } =
            state.armes.signalerArmePerdueVolee.recuperer;
        return {
            dataProfil: data,
            message,
            erreur,
            isLoading,
            isLoadingListeArme,
            dataListeArme,
        };
    },
    {
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(FormulaireArmePerdueVolee);
